import { render, staticRenderFns } from "./StreakAchieved.vue?vue&type=template&id=3854050b&scoped=true"
import script from "./StreakAchieved.vue?vue&type=script&lang=js"
export * from "./StreakAchieved.vue?vue&type=script&lang=js"
import style0 from "./StreakAchieved.vue?vue&type=style&index=0&id=3854050b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3854050b",
  null
  
)

export default component.exports